export default __webpack_public_path__ + "static/media/Venturer's Vambraces of the Roaring Jungle.6e12f951.jpg";